import { render, staticRenderFns } from "./NewList.vue?vue&type=template&id=7c4cf910&scoped=true&"
import script from "./NewList.vue?vue&type=script&lang=js&"
export * from "./NewList.vue?vue&type=script&lang=js&"
import style0 from "./NewList.vue?vue&type=style&index=0&id=7c4cf910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4cf910",
  null
  
)

export default component.exports